import React, { useState } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { Info, Edit, History, Close } from '@material-ui/icons';

import Table from '~/components/Table';
import { useAssociations } from '~/services/hooks/useAssociations';
import { Association } from '~/types';
import DetailsDialog from '~/components/DetailsDialog';
import DataTree, { DataGroup, TextDataItem } from '~/components/DataTree';
import { Title } from '~/components/Title';
import PicktowHistoryCard from '~/components/PicktowHistoryCard';

interface AssociationManagerParams { }

interface AssociationManagerLocationState { }

type AssociationManagerProps = RouteChildrenProps<AssociationManagerParams, AssociationManagerLocationState>;

export function AssociationManager(props: AssociationManagerProps) {
  const { associations, loading } = useAssociations();

  const [association, setAssociation] = useState<Association>();
  const [historyAssociation, setHistoryAssociation] = useState<Association>();

  const handleEditAssociation = (data: Association | Association[]) => {
    const associationEditing = Array.isArray(data) ? data[0] : data;
    props.history.push(`/association/${associationEditing.id}`);
  };

  const handleViewHistory = (data: Association | Association[]) => {
    const selectedAssociation = Array.isArray(data) ? data[0] : data;
    setHistoryAssociation(selectedAssociation);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 20 }}>
        <Title style={{ flex: 1 }}>Gerenciamento de Empresas</Title>
        <Button
          variant='contained'
          color='secondary'
          style={{ textTransform: 'none', padding: '10px 15px' }}
          onClick={() => props.history.push('/association')}
        >
          Cadastrar
        </Button>
      </div>

      <Table
        columns={{
          code: 'Código',
          company_name: 'Razão Social',
          trading_name: 'Nome Fantasia',
          pohone_number: 'Telefone',
          email: 'Email',
          'address_response.city': 'Cidade',
          'address_response.neighborhood': 'Bairro',
        }}
        data={associations}
        actions={[
          {
            icon: () => <Info />,
            tooltip: 'detalhes',
            onClick: (event, data) => setAssociation(data as Association),
          },
          {
            icon: () => <Edit />,
            tooltip: 'Editar',
            onClick: (_, data) => handleEditAssociation(data),
          },
          {
            icon: () => <History />,
            tooltip: 'Histórico',
            onClick: (_, data) => handleViewHistory(data),
          },
        ]}
        localization={{
          body: {
            emptyDataSourceMessage: 'Sem empresas',
          },
          pagination: {
            labelRowsSelect: 'empresas',
          },
          header: {
            actions: '',
          },
        }}
        options={{
          showTitle: false,
        }}
        isLoading={loading}
      />

      <DetailsDialog open={!!association} onClose={() => setAssociation(undefined)}>
        <DataTree>
          <DataGroup title='Detalhes da Empresa'>
            <TextDataItem title='ID' value={association?.id} />
            <TextDataItem title='Cobrança pelo excedente' value={association?.charge_excess ? 'Sim' : 'Não'} />
            <TextDataItem
              title='Serviços com Origem e Destino diferentes?'
              value={association?.diff_source_destination ? 'Sim' : 'Não'}
            />
          </DataGroup>
        </DataTree>
      </DetailsDialog>

      <Dialog open={!!historyAssociation} onClose={() => setHistoryAssociation(undefined)} maxWidth='lg' fullWidth>
        <DialogTitle>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Histórico - {historyAssociation?.trading_name || historyAssociation?.company_name}</span>
            <IconButton onClick={() => setHistoryAssociation(undefined)} size='small'>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          {historyAssociation && (
            <PicktowHistoryCard
              associationId={historyAssociation.id}
              associationName={historyAssociation.trading_name || historyAssociation.company_name}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default AssociationManager;
